import axios from 'axios'

import { getEnvUrls } from 'helpers/envUrls'
import { isEmpty } from 'helpers/lodash'
import { accessTokenHelper } from 'helpers/token'

const MEETS_BASE_URL = process.env.REACT_APP_MEETS_BASE_URL
const OHR_BASE_URL = process.env.REACT_APP_OHR_V1_BASE_URL

const apiTypes = {
    ohm: 'ohm',
    ohr: 'ohr',
}

const changeBaseURL = (config, type) => {
    if (!isEmpty(apiTypes[type])) {
        const { MEETS_BASE_URL, OHR_V1_BASE_URL } = getEnvUrls()

        config.baseURL =
            type === apiTypes.ohm ? MEETS_BASE_URL : OHR_V1_BASE_URL
    }

    return config
}

const getAxios = ({
    baseURL = '',
    type = 'ohm',
    registerInterceptor = false,
}) => {
    const instance = axios.create({
        baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
    })

    if (registerInterceptor) {
        instance.interceptors.request.use(
            config => {
                changeBaseURL(config, type)

                // Check if User is authenticated or not
                const token = accessTokenHelper.get()
                if (token) {
                    config.headers = {
                        Authorization: `Bearer ${token}`,
                    }
                }

                return config
            },
            error => {
                return error
            }
        )
    } else {
        // register request interceptor for dynamic baseURL for all in one app
        instance.interceptors.request.use(
            config => {
                changeBaseURL(config, type)

                return config
            },
            error => {
                return error
            }
        )
    }

    return instance
}

export const meetsAxiosOpen = getAxios({
    baseURL: MEETS_BASE_URL,
    type: apiTypes.ohm,
})
export const meetsAxiosProtected = getAxios({
    baseURL: MEETS_BASE_URL,
    registerInterceptor: true,
    type: apiTypes.ohm,
})
export const ohrAxiosOpen = getAxios({
    baseURL: OHR_BASE_URL,
    type: apiTypes.ohr,
})
export const ohrAxiosProtected = getAxios({
    baseURL: OHR_BASE_URL,
    registerInterceptor: true,
    type: apiTypes.ohr,
})
